import { useCallback, useEffect, useState } from 'react';
import api from '../lib/api';

export default function useAccessControl() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    api.get('/users/me')
      .then((res) => { if (mounted) setUser(res.data); })
      .catch(() => { if (mounted) setUser(null); })
      .finally(() => { if (mounted) setLoading(false); });
    return () => { mounted = false; };
  }, []);

  const can = useCallback((permission) => {
    if (!user) return false;
    if (!user.staff_account) return true;
    const permissions = user.permissions || [];
    return permissions.includes('*') || permissions.includes(permission);
  }, [user]);

  return { user, loading, can, isStaff: !!user?.staff_account };
}
